import "./Apropos.scss";
import maman from "../../Images/maman.jpg";
import {useEffect} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGem, faLeaf } from "@fortawesome/free-solid-svg-icons";

function Apropos() {
    useEffect(() => {
        document.title = "A propos";
    }, []);

    return (
        <div className="apropos-container">
            <section className="apropos-hero">
                <div className="hero-content">
                    <h1>Anne-Sophie</h1>
                    <p className="lead-text">
                        Je me présente, je suis Anne-Sophie, une passionnée de 50 ans qui a plongé dans l'univers envoûtant des pierres naturelles il y a une décennie.
                    </p>
                    <p>
                        Cette aventure a profondément transformé ma vie et m'a inspirée à explorer les innombrables possibilités créatives que ces trésors de la nature offrent. Depuis les deux dernières années, j'ai embrassé ma passion en tant que créatrice de bijoux et d'accessoires confectionnés avec des pierres naturelles. 
                    </p>
                </div>
                <div className="hero-image-wrapper">
                    <img src={maman} alt="Anne-Sophie de Anneso-Naturelle" />
                </div>
            </section>

            <section className="apropos-vision">
                <h2>Ma Vision</h2>
                <p>
                    "Chaque création que je façonne porte en elle une énergie spéciale, puisée dans les vibrations uniques de ces pierres, pour vous accompagner dans votre voyage personnel."
                </p>
                <p>
                    Mon objectif est de vous offrir des pièces uniques qui transcendent le simple aspect esthétique pour devenir de véritables compagnons de votre quotidien. C'est bien plus qu'une simple collection de bijoux. C'est une expérience holistique où la méditation et la relaxation se mêlent à l'esthétique, créant une harmonie entre le physique et le spirituel.
                </p>
            </section>

            <section className="apropos-details">
                <div className="detail-card">
                    <h3><FontAwesomeIcon icon={faGem} /> Les Pierres Naturelles</h3>
                    <p>
                        Les pierres naturelles que j'utilise sont soigneusement sélectionnées non seulement pour leur beauté, mais aussi pour leurs propriétés énergétiques spécifiques. 
                    </p>
                    <p>
                        Chaque pièce devient ainsi une invitation à la contemplation, un pont entre le matériel et le spirituel. Naviguez à travers les différentes rubriques de ma collection, et vous découvrirez bien plus qu'une simple gamme de bijoux. Vous trouverez des sections dédiées à l'amélioration de votre bien-être personnel, où je partage des conseils pratiques et des techniques de méditation.
                    </p>
                </div>
                
                <div className="detail-card">
                    <h3><FontAwesomeIcon icon={faLeaf} /> Bien-être & Harmonie</h3>
                    <p>
                        Mais ce n'est pas tout, car je crois fermement que notre bien-être est intrinsèquement lié à celui de notre environnement.
                    </p>
                    <p>
                        C'est pourquoi vous trouverez également des suggestions et des idées pour créer une atmosphère paisible et équilibrée autour de vous, en harmonie avec les énergies de la nature. Au fil des pages, plongez dans un monde où la créativité, la spiritualité et le bien-être se rejoignent.
                    </p>
                </div>
            </section>

            <footer className="apropos-footer">
                <p>
                    Laissez-vous emporter par l'énergie positive des pierres naturelles et découvrez comment elles peuvent enrichir votre vie de manière profonde et significative. Bienvenue dans mon univers où chaque bijou, chaque accessoire, est une invitation à vous reconnecter avec vous-même et avec le monde qui vous entoure.
                </p>
            </footer>
        </div>
    );
}

export default Apropos;
